import LogRocket from 'logrocket';
import { useEffect } from 'react';

import { useCurrentUser } from '@/hooks/useCurrentUser';

export function UserAnalyticsProvider() {
  const { user } = useCurrentUser();

  useEffect(() => {
    if (user && user.id && import.meta.env.VITE_LOGROCKET_APP_ID) {
      LogRocket.identify(user.id, {
        name: user.name,
        email: user.email,
        // add any other custom fields if needed
      });
    }
  }, [user]);

  return null; // This component doesn't render anything visible
}
